import React from 'react';
import { Form, Button, Alert } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { FormGroup, Label, Row, Col } from 'reactstrap';
import { ReduxTextAreaInput, ReduxSpinner } from '../../components/ReduxInput';
import { ENGINE_METHOD_DIGESTS } from 'constants';

class NotesForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            edit: false,
            editFuel: false
        };
        this.editClicked = this.editClicked.bind(this);
        this.editFuelClicked = this.editFuelClicked.bind(this);
    }

    editClicked(ev) {
        ev.preventDefault();
        this.setState({
            edit: true
        });
    }

    editFuelClicked(ev) {
        ev.preventDefault();
        this.setState({
            editFuel: true
        });
    }


    render() {
        const { handleSubmit, notes, fuel } = this.props;
        let { edit, editFuel } = this.state;
        return (

            <Form onSubmit={handleSubmit}>
                <Row>
                    <Col xs='12' >
                        <Label>Accessorial Quote Note</Label>
                    </Col>
                </Row>
                {edit ?
                    <Row>
                        <Col xs='11' className="pb-2">
                            <Field
                                type="text"
                                id="notes"
                                name="notes"
                                placeholder="New Text"
                                rows="1"
                                cols="75"
                                name="notes"
                                component={ReduxTextAreaInput}
                            />
                        </Col>
                        <Col md='1' >
                            <Button
                                type="submit"
                                color="primary"
                            >Save</Button>
                        </Col>
                    </Row>
                    :
                    <Row>
                        <Col xs='11' >
                            <Alert color="success">
                                {notes || "<no current text>"}
                            </Alert>
                        </Col>
                        <Col md='1' >
                            <Button
                                onClick={this.editClicked}
                                color="primary"
                            >Edit</Button>
                        </Col>
                    </Row>


                }

                {editFuel ? 
                    <Row>
                        <Col xs='12' >
                            <Label>Fuel Surcharge</Label>
                        </Col>
                    
                        <Col md='11'>
                            <Field
                                id="fuelSurcharg"
                                name="fuelSurcharge"
                                min={0}
                                max={100}
                                component={ReduxSpinner}
                            />
                        </Col>
                        <Col md='1' >
                            <Button
                                type="submit"
                                color="primary"
                            >Save</Button>
                        </Col>
                    </Row>
                
                    : <Row>
                                        <Col xs='12' >
                            <Label>Fuel Surcharge</Label>
                        </Col>
                        <Col xs='11' >
                            <Alert color="success">
                                {fuel || "<no current text>"}
                            </Alert>
                        </Col>
                        <Col md='1' >
                            <Button
                                onClick={this.editFuelClicked}
                                color="primary"
                            >Edit</Button>
                        </Col>
                    </Row>
                }
            </Form>
        );
    }
}

export default reduxForm({
    form: 'NotesForm', // a unique identifier for this form
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true
})(NotesForm);



// WEBPACK FOOTER //
// ./src/components/AccessorialsAndFees/NotesForm.js